import Reject from '@/views/borrows/rejects/Index'
import List from '@/views/borrows/rejects/List'
import Show from '@/views/borrows/rejects/Show'
import Permissions from '@/permissions'

export const rejectRouters = {
  path: 'rejected',
  name: 'rejected',
  component: Reject,
  redirect: 'rejected',
  meta: {
    permissions: [Permissions.backend.rejected.manage],
    groups: 'rejected'
  },
  children: [
    {
      path: '',
      name: 'list-rejected',
      component: List,
      meta: {
        permissions: [Permissions.backend.rejected.list],
        groups: 'rejected',
        breadcrumb: [
          {
            name_en: 'Rejected',
            name_km: 'សំន្នើសុំដែលបានបដិសេធ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'show/:borrow_id',
      name: 'show-rejected',
      component: Show,
      meta: {
        permissions: [Permissions.backend.rejected.show],
        groups: 'rejected',
        breadcrumb: [
          {
            name_en: 'Rejected',
            name_km: 'សំន្នើសុំដែលបានបដិសេធ'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
